var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.inLimbo)?_c('layout-common',_vm._b({},'layout-common',_vm.props,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }